import manifest from "../manifest.template.json";
export var PLUGIN_ID = manifest.id;
export var WINDOW_DIMS = {
    width: 440,
    height: 584,
};
